import { useTranslation } from 'next-i18next'
import { TfiArrowCircleDown } from 'react-icons/tfi'
import { IoTriangleSharp } from 'react-icons/io5'
import { FC, useContext, useEffect, useState } from 'react'
import { useModalAction } from '@components/common/modal/modal.context'
import { useMutation } from 'react-query'
import saveListService from '@services/savelistservice'
import { toast } from 'react-toastify'
import { IUser } from '@contexts/user/user.utils'
import { UserContext } from '@contexts/user/user.context'
import { ImSpinner2 } from 'react-icons/im'
import { useAddWishListItemMutation } from '@framework/savelist/add-wishlist-item'

export interface UpdateList {
  list_name: string
  skus: string
  qty: number
}
const ProductAddToList: FC<any> = ({ data, addtocartQty }) => {
  const { t: translate } = useTranslation(['common', 'savelist'])
  const [loader, setLoader] = useState(null)
  const { t } = useTranslation()
  const [showList, setShowList] = useState(false)
  const { openModal } = useModalAction()
  const { user } = useContext(UserContext) as IUser
  const [savedLists, setSavedLists] = useState([])
  const { addWishlistItem, whishListLoading } = useAddWishListItemMutation()

  const fetchSavedLists = async (isNewListAdded?) => {
    try {
      const response: any = await saveListService.getSavedLists(user.id)
      let responseData = Array.isArray(response) ? response : [response]
      setSavedLists(responseData)
      if (isNewListAdded)
        updateSavedList(responseData[responseData.length - 1].list_id)
    } catch (err) {
      toast.error(err?.message, { className: 'toast-error' })
    }
  }

  useEffect(() => {
    if (user?.id) {
      fetchSavedLists()
    }
  }, [])

  const { mutate } = useMutation(
    ({ list_id, payload }: { list_id: string; payload: UpdateList }) => {
      return saveListService.updateSavedList(list_id, payload)
    },
    {
      onSuccess: (response: any) => {
        if (response === 'Sku already exist in the selected list')
          toast.error(response, { className: 'toast-error' })
        else toast.success(response)
        setLoader(null)
      },
      onError: (err: Error) => {
        setLoader(null)
        toast.error(`Error list updation: ${err?.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error',
        })
      },
    },
  )

  const updateSavedList = (list_id) => {
    setLoader(list_id)
    let payload = {
      list_name: '',
      skus: data?.sku,
      qty: data?.min_sale_qty ?? 1,
      customer_id: user?.id,
    }

    mutate({ list_id, payload })
  }

  const openPopup = () => {
    openModal('CREATE_NEW_LIST_POPUP', { fetchSavedLists })
  }
  const handleWishlistClick = async () => {
    const payload = {
      product_id: data?.entity_id,
      qty: 1,
      forceRemoveFromCart: false,
      vendor_id: process?.env?.NEXT_PUBLIC_VENDOR_ID,
      config_option: {},
    }
    addWishlistItem(payload)
  }

  return (
    <div>
      <p
        className="underline text-brand font-medium flex items-center hover:cursor-pointer"
        onClick={() => setShowList(!showList)}
      >
        <span className="mr-1.5 whitespace-nowrap">
          {translate('text-add-to-list', { ns: 'savelist' })}
        </span>
        <TfiArrowCircleDown fontSize={18} />
      </p>

      {showList && (
        <div>
          <IoTriangleSharp className="text-fill-base -mb-1 ml-[85px]" />
          <ul className="w-[170px] bg-fill-base text-brand text-xs p-2 font-semibold ">
            <li
              className="underline mb-1 hover:cursor-pointer"
              onClick={openPopup}
            >
              {translate('text-new-list', { ns: 'savelist' })}
            </li>
            {!whishListLoading ? (
              <li
                onClick={handleWishlistClick}
                className="hover:underline py-0.5 hover:cursor-pointer"
              >
                {translate('text-save-for-later', { ns: 'common' })}
              </li>
            ) : (
              <ImSpinner2 className="w-4 h-4 animate-spin ltr:-mr-1 rtl:-ml-1  rtl:mr-3 " />
            )}

            {savedLists?.length < 1
              ? null
              : savedLists.map(({ list_id, list_name }, index) => {
                  return (
                    <li
                      key={index}
                      onClick={() => updateSavedList(list_id)}
                      className="hover:underline py-0.5 hover:cursor-pointer"
                    >
                      {loader !== list_id ? (
                        list_name
                      ) : (
                        <ImSpinner2 className="w-4 h-4 animate-spin ltr:-mr-1 rtl:-ml-1  rtl:mr-3 " />
                      )}
                    </li>
                  )
                })}
          </ul>
        </div>
      )}
    </div>
  )
}

export default ProductAddToList
